import { makeAutoObservable } from "mobx";

/**
 * Chat store for managing real-time messaging and communication state
 * Handles message history, typing indicators, and call state synchronization
 */
class chatStore {

  /**
   * Initialize the chat store
   * Sets up MobX observables for reactive state management
   */
  constructor() {
    makeAutoObservable(this);
  }

  /** @type {Array} Array of chat messages */
  messages = [];

  /** @type {boolean} Whether user is currently typing */
  isTyping = false;

  /** @type {Object} Current call state data */
  callState = {};

  /** @type {number} Number of unread messages */
  unreadMessages = 0;

  /**
   * Set the complete messages array
   * @param {Array} messages - Array of message objects
   * @returns {void}
   */
  setMessages(messages) {
    this.messages = messages;
  }

  /**
   * Add a new message to the chat
   * Handles both text and file message types
   * @param {Object} message - Message object with sender, content, and metadata
   * @returns {void}
   */
  addMessage(message) {
    if (message.message.type === 'file') {
      this.messages.push({
        ...message,
        message: {
          type: 'file',
          content: JSON.parse(message.message.content)
        }
      });
    } else {
      this.messages.push(message);
    }
  }

  /**
   * Get all chat messages
   * @returns {Array} Array of message objects
   */
  getMessages() {
    return this.messages;
  }

  /**
   * Set typing indicator state
   * @param {boolean} isTyping - Whether user is typing
   * @returns {void}
   */
  setIsTyping(isTyping) {
    this.isTyping = isTyping;
  }

  /**
   * Set current call state data
   * @param {Object} callState - Call state object
   * @returns {void}
   */
  setCallState(callState) {
    this.callState = callState;
  }

  /**
   * Set number of unread messages
   * @param {number} unreadMessages - Count of unread messages
   * @returns {void}
   */
  setUnreadMessages(unreadMessages) {
    this.unreadMessages = unreadMessages;
  }
}

const ChatStore = new chatStore();

export default ChatStore;